import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';

type InputProps = React.InputHTMLAttributes<HTMLTextAreaElement>;

export interface TextAreaProps extends InputProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export const TextArea = ({
  label,
  id,
  tooltip,
  field,
  type,
  onValueChange,
  defaultValue,
  ...rest
}: TextAreaProps) => (
  <BaseForm label={label} id={id} tooltip={tooltip}>
    <textarea
      id={id}
      className={`${theme.form.field.input} r-vertical h4`}
      onChange={(e) => onValueChange(field, e.target.value)}
      {...rest}
    >
      {defaultValue}
    </textarea>
  </BaseForm>
);
